<template>
  <div :class="['is-' + type, {'has-join-bar': isLanding && $route.path === '/'}]" class="nav-container">
    <b-navbar :type="'is-white'" class="main-nav">
      <template slot="brand">
        <a v-if="!loggedIn" :href="'/'" class="navbar-item">
          <img class="logo" src="/swf-logo-dark.svg">
        </a>
        <b-navbar-item v-else :to="'/decks/'" tag="n-link">
          <img class="logo" src="/swf-logo-dark.svg">
        </b-navbar-item>
      </template>
      <template slot="start">
        <!-- <b-navbar-item /> -->
      </template>

      <template slot="end">
        <b-navbar-item v-if="!loggedIn" tag="div">
          <!-- <n-link :to="'/go'" class="button is-text"><span>Join Event</span></n-link> -->
          <a href="/templates" class="button is-text"><span>Templates</span></a>
          <a href="/pricing" class="button is-text"><span>Pricing</span></a>
          <a href="/blog" class="button is-text"><span>Blog</span></a>

          <div @click="toggleVideoMenu()" class="button is-text video-dropdown">
            <span>📺 Videos </span>
            <span style="margin-left: 0px; font-size: .9em; margin-top: 1px;" class="icon">
              <i class="fas fa-angle-down" />
            </span>
          </div>

          <div class="buttons">
            <n-link :to="'/login'" class="button is-text"><span>Log in</span></n-link>
            <n-link :to="'/register'" class="button is-primary">
              <strong>Sign Up</strong>
            </n-link>
          </div>
        </b-navbar-item>

        <b-navbar-item v-if="loggedIn" tag="div">
          <div>
            <n-link :to="'/account/refer'" class="button is-text"><span @click="posthogCapture('referral:navbar_link_click')">🎁 Refer a Friend</span></n-link>
            <n-link :to="'/decks'" class="button is-text"><span>My Decks</span></n-link>
            <n-link :to="'/templates'" class="button is-text"><span>Templates</span></n-link>
            <b-tooltip :active="shouldDisplayAnalyticsOnboarding" class="analytics-tooltip is-wide" position="is-bottom" multilined always>
              <n-link :to="'/analytics'" v-if="!isLanding && !isBlog" class="button is-text">
                <span>Analytics</span>
              </n-link>
              <template v-slot:content>
                <div class="is-flex">
                  <div>
                    <h6 class="title is-5 has-text-white">See what’s new</h6>
                    <p class="subtitle is-6">
                      We’ve upgraded your old Events page into a full Analytics hub!
                    </p>
                  </div>
                  <div @click="dismissAnalyticsOnboarding" class="close-button">
                    <i class="fas fa-times" />
                  </div>
                </div>
              </template>
            </b-tooltip>

            <div @click="toggleVideoMenu()" v-if="!isLanding" class="button is-text video-dropdown">
              <span>📺 Tutorials </span>
              <span style="margin-left: 0px; font-size: .9em; margin-top: 1px;" class="icon">
                <i class="fas fa-angle-down" />
              </span>
            </div>

            <!-- <a href="/blog" class="button is-text">
              <span>Blog</span>
            </a> -->

            <n-link :to="'/account'" v-if="!isLanding" class="button is-text profile" style="margin-right: -.5em">
              <span>Profile</span>
              <span v-if="isSubscriber && !isPassActive" class="tag is-small is-secondary m-l-5 plan capitalize">{{ userPlan }}</span>
              <span v-if="isPassActive" class="tag is-small is-secondary m-l-5 plan">{{ passes.daysLeft }} days of <span>&nbsp;{{ passes.bestPass }}</span></span>
            </n-link>

            <template>
              <span v-if="!isSubscriber" @click="startUpgrade()" class="button is-primary upgrade is-outlined">
                <b>Upgrade</b>
                <span class="flourish">✨</span>
              </span>
            </template>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>
    <div v-if="showVideoMenu" :class="{'isActive': showVideoMenu, 'isPlayer': playingVideo }" class="video-menu">
      <style> html body { overflow: hidden; } </style> <!-- prevent body scroll while menu open -->
      <template v-if="!playingVideo.src">
        <div @click="playVideo('🎮 Gameplay Demo', 'https://player.vimeo.com/video/504440973?autoplay=1&controls=1&share=1')" class="vid">
          <p>🎮 Gameplay Demo</p>
          <img :src="cfResize('/tutorials/gameplay-demo.jpg', {w: 300, h: 225, fit: 'scale-down'})" width="300px" height="225px">
        </div>

        <div @click="playVideo('🚀 Quick Start', 'https://player.vimeo.com/video/606837324?autoplay=1')" class="vid">
          <p>🚀 Quick Start</p>
          <img :src="cfResize('/tutorials/quick-start.jpg', {w: 300, h: 225, fit: 'scale-down'})" width="300px" height="225px">
        </div>

        <div @click="playVideo('🎬 Host an Event', 'https://player.vimeo.com/video/606837300?autoplay=1')" class="vid">
          <p>🎬 Host an Event</p>
          <img :src="cfResize('/tutorials/host-an-event.jpg', {w: 300, h: 225, fit: 'scale-down'})" width="300px" height="225px">
        </div>

        <div @click="playVideo('Build a Slide Deck', 'https://player.vimeo.com/video/606837244?autoplay=1')" class="vid">
          <p>Build a Slide Deck</p>
          <img :src="cfResize('/tutorials/deck-basics.jpg', {w: 300, h: 225, fit: 'scale-down'})" width="300px" height="225px">
        </div>

        <div @click="playVideo('Advanced Deck Building', 'https://player.vimeo.com/video/606837129?autoplay=1')" class="vid">
          <p>Advanced Deck Building</p>
          <img :src="cfResize('/tutorials/deck-advanced.jpg', {w: 300, h: 225, fit: 'scale-down'})" width="300px" height="225px">
        </div>
        <div @click="playVideo('📊 Slide Type Details', 'https://player.vimeo.com/video/606837367?autoplay=1')" class="vid">
          <p>Slide Type Details</p>
          <img :src="cfResize('/tutorials/slide-types.jpg', {w: 300, h: 225, fit: 'scale-down'})" width="300px" height="225px">
        </div>
      </template>

      <div v-if="playingVideo.src" class="video-player">
        <p class="title is-4">{{ playingVideo.title }}</p>
        <div class="video-bg" style="position: relative; padding-bottom: 56.25%; height: 0;">
          <iframe :src="playingVideo.src" class="loom-video" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen />
        </div>
        <div @click="playingVideo = {}" class="go-back m-t-20">
          <i class="fas fa-long-arrow-alt-left" /> back to all videos
        </div>
      </div>
      <div @click="toggleVideoMenu()" class="close-menu"><i class="fas fa-times" /></div>
    </div>
    <div v-if="showVideoMenu" @click="toggleVideoMenu()" class="video-backdrop" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

import { isBefore } from 'date-fns'
import UpgradeAccount from '~/components/modals/UpgradeAccount'
import ExtendPass from '~/components/modals/ExtendPass'

export default {
  props: ['type'],
  data () {
    return {
      joinCode: '',
      newDeckModal: false,
      showVideoMenu: false,
      playingVideo: {},
      loggedIn: false,
      showUpgradeModal: false,
      firstEduLogin: false,
      hasSkippedAnalyticsOnboarding: false
    }
  },
  computed: {
    ...mapState([
      'user',
      'slideDecks'
    ]),
    ...mapGetters([
      'isSubscriber',
      'userPlan',
      'isPassHolder',
      'isPassActive',
      'eventPasses'
    ]),
    passes () {
      return this.eventPasses || {}
    },
    isBlog () {
      return this.type === 'blog'
    },
    isLanding () {
      return this.type === 'landing'
    },
    isClient () {
      return process.client
    },
    shouldDisplayAnalyticsOnboarding () {
      return (
        isBefore(new Date(this.$store.state.user.createdAt), new Date('2025-08-27')) &&
        !this.hasOnboarded('analytics-onboarding')
      ) && !this.hasSkippedAnalyticsOnboarding
    }
  },
  watch: {
    'user.id' (newVal, oldVal) {
      if (oldVal == null && newVal != null) {
        if (this.showUpgradeModal === true) {
          this.log('user just loaded with upgrade hash, showing modal')
          this.showUpgradeModal = false
          this.startUpgrade()
        }
      }
    },
    '$route.path': {
      handler (newPath) {
        if (newPath.startsWith('/analytics')) {
          this.dismissAnalyticsOnboarding()
        }
      }
    }
    // UPDATE: NOT AUTO-SHOWING UPGRADE MODAL

    // launch upgrade modal one time (first login typically) for all unpaid users
    // 'user.stripe_customer' (val) {
    //   // only load modal for unpaid users
    //   if (val && val.length > 12) { return }
    //   if (!this.user?.id || !this.user.onboardCues) {
    //     this.log('user not logged in, not opening modal')
    //     return
    //   }
    //   // launch pricing modal if they haven't seen ANY upgrade modals yet:
    //   if (!this.hasOnboarded('edu-upgrade-modal') && !this.hasOnboarded('upgrade-modal')) {
    //     this.startUpgrade(true)
    //     this.saveOnboarding('upgrade-modal')
    //   }
    // }
  },
  created () {
    // if (this.$route.hash === '#videos') {
    //   this.$router.replace({ hash: '' })
    //   this.showVideoMenu = true
    // }
  },
  mounted () {
    this.loggedIn = this.$store.state.auth.loggedIn

    if (this.$route.hash === '#videos') {
      this.showVideoMenu = true
      this.$router.replace({ hash: '' })
    }

    if (this.$route.hash === '#upgrade') {
      this.log('starting upgrade modal')
      if (this.user.id) {
        this.showUpgradeModal = false
        this.startUpgrade()
      } else {
        this.log('user not loaded, delaying start of upgrade modal')
        this.showUpgradeModal = true
      }
    }

    this.checkPassNotices()
  },
  methods: {
    dismissAnalyticsOnboarding () {
      this.hasSkippedAnalyticsOnboarding = true
      if (!this.hasOnboarded('analytics-onboarding')) {
        this.saveOnboarding('analytics-onboarding')
      }
    },

    checkPassNotices () {
      if (this.isPassHolder && this.passes.daysLeft > 28) {
        this.showNewPassNotice()
      }
    },
    showNewPassNotice () {
      if (this.hasSeenHint('new-pass-purchase')) { return }

      this.$buefy.toast.open({
        duration: 5000,
        message: `🙌 Purchase successful!`,
        type: 'is-secondary'
      })

      this.saveUserHint('new-pass-purchase')
    },
    playVideo (title, src) {
      this.playingVideo = {
        src
      }
    },
    toggleVideoMenu () {
      this.showVideoMenu = !this.showVideoMenu
      this.playingVideo = {}
    },
    async logout () {
      await this.$auth.logout()
      await this.$apolloHelpers.onLogout()
    },
    startUpgrade (isFirstLogin) {
      if (this.$route.hash !== '#upgrade') {
        this.log('router not showing upgrade hash, adding it')
        this.$router.replace({ hash: 'upgrade' })
        this.trackEvent('Upgrade Modal')
      }

      if (!this.user.id) {
        this.loadingUser = true
      }

      if (this.isPassActive) {
        this.log('active pass, opening extend modal')
        this.$buefy.modal.open({
          parent: this,
          fullScreen: true,
          component: ExtendPass,
          customClass: 'upgrade-modal',
          canCancel: false,
          trapFocus: true,
          props: {
            from_location: 'navbar',
            button_text: 'Upgrade'
          },
          onCancel: () => {
            this.$router.replace({ hash: '' })
          }
        })
      } else {
        this.log('no pass active, opening upgrade modal')
        this.$buefy.modal.open({
          parent: this,
          fullScreen: true,
          component: UpgradeAccount,
          customClass: 'upgrade-modal',
          canCancel: isFirstLogin || false, // allow cancel on first pop-up for edu users, but not if they opened it themself
          trapFocus: true,
          props: {
            firstLogin: isFirstLogin,
            from_location: 'navbar',
            button_text: 'Upgrade'
          },
          onCancel: () => {
            this.$router.replace({ hash: '' })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
body.no-scroll {
  overflow: hidden;
}
.navbar .dropdown-menu {
  min-width: 0;
}
.nav-container {
  position: relative;
}

.join-bar {
  height: 51px;

  .is-small .input {
    font-size: .9rem;
    text-transform: uppercase;
    // font-weight: bold;
    color: #888;
    width: 160px;
  }
  .icon.is-small.is-right {
    font-size: .9rem !important;

    i {
      font-size: 1.6em;
      margin-right: 2px;
    }
  }
}
</style>
<style lang="scss" scoped>
@media (max-width: 768px) {
  .join-bar {
    height: 94px;
    flex-direction: column;

    p {
      line-height: .9em;
      margin-left: 3px;
      margin-bottom: 12px;
    }
  }
}
.join-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #777;
  font-size: .9em;
  padding: 7px;
  margin-bottom: 10px;
  // background-color: #eee; // var(--primary);
  // background: linear-gradient(to right, white 0%, #e7fbff 100%);
  // background: linear-gradient(25deg, #f3f5f9 0%, #fff 35%, #fff 50%, #f3f5f9 100%);
  // background: linear-gradient(25deg, #fdfeff 0%, #f3f7fa 25%, #f3f7fa 60%, #fdfeff 100%);
  background-color: #f3f7fa;
  border-bottom: 1px solid #dce6e8;

  .control {

  }
}
.loom-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .watch-on-loom {
    display: none !important;
  }
}

.is-landing {
  .video-backdrop, .video-menu  {
    top: 85px;
  }

  &.has-join-bar {
    .video-backdrop, .video-menu  {
      top: 152px;
    }
  }
}

.main-nav .button.upgrade {
  margin-left: 10px;
  margin-right: -6px;

  .flourish {
    margin-left: 2px;
    margin-right: -4px;
  }
}

.video-player {
  width: 800px;
  margin-top: 20px;

  .video-bg{
    background-color: #eee;
    border-radius: 4px;
    overflow: hidden;
  }
}
  .video-backdrop {
    position: fixed;
    top: 118px;
    width: 100%;
    left: 0; bottom: 0;
    background-color: rgba(0,0,0,.2);
    z-index: 5;
  }

.video-menu {
  height: auto;
  opacity: 0;
  transition: opacity .2s ease;
  position: absolute;
  top: 67px;
  background-color: white;
  width: 100vw;
  left: 0;
  right: 0;
  z-index: 50;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1);
  padding:  40px 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  &.isActive {
    opacity: 1;
  }

  &.isPlayer {
    height: auto;
    padding-left: calc(50% - 500px);
    padding-right: calc(50% - 500px);
  }

  .close-menu {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 1.2em;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: .4;
    background-color: rgba(0,0,0,0);
    border-radius: 50px;
    cursor: pointer;
    transition: background-color .3s ease, opacity .2s ease;

    &:hover {
      opacity: .6;
      background-color: rgba(0,0,0,0.1);
    }
  }

  .go-back {
    cursor: pointer;
    text-decoration: underline;
  }

  .vid {
    position: relative;
    text-align: center;
    cursor: pointer;
    margin: 10px 0px 15px;

    &:after {
      content: '▶';
      position: absolute;
      display: flex;
      font-size: 1.2em;
      padding-bottom: 3px;
      justify-content: center;
      align-items: center;
      bottom: 35%;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 60px;
      height: 40px;
      border-radius: 4px;
      color: white;
      background-color: rgba(0,0,0,.4);
    }

    &:hover {
      &:after {
        background-color: rgba(0,0,0,.6);
      }
    }

    img {
      max-width: 300px;
      border-radius: 4px;
      overflow: hidden;
    }

    &:not(:last-of-type) {
      margin-right: 30px;
    }

    p {
      font-size: 1.1em;
      margin-bottom: 8px;
      font-weight: bold;
    }
  }
}

.logo {
  height:1.5em;
  transform: scale(1.8); // this tweaks rendering sharpness
  padding-left:48px;
  padding-right:10px;
}

.no-gradient .navbar {
  background-image: none;
  background-color: #f3f5f9;
}

.is-landing {
  margin-bottom: 30px;
  .navbar {
    padding: 15px 15px 5px 10px;
  }

  .logo {
    transform: scale(1.9);
    position: relative;
    top: -4px;
  }

  .video-menu {
    border-top: 1px solid var(--light-blue);
  }

}

.navbar {
  position: relative;
  border-bottom: 1px solid var(--med-blue);
  // background-color: #f3f5f9;
  // background-color: #fbfcfd;
  background-color: #fafbfc;
  // background-image: linear-gradient(25deg, #fff 0%, #f3f5f9 35%, #f3f5f9 50%, #fff 100%);
  background-image: linear-gradient(25deg, #fff 0%, #f9fafd 25%, #f8f9fc 60%, #fff 100%);

  &.is-transparent {
    border-bottom: none;
    background-image: none;
    background-color: transparent;
  }

  a:hover{
    // background-color:transparent !important;
    box-shadow: 0px 1px 10px rgba(0,0,0,.015);
  }

  .navbar-brand a:hover {
    background-color:transparent !important;
  }

  .button {
    &.is-text {
      text-decoration: none;

      &:hover span {
        text-decoration: underline;
      }

      &.profile .tag {
        text-decoration: none;
        padding: 0px 4px 2px;
        height: auto;
        transform: scale(.9);

        span {
          text-transform: capitalize;
        }
      }
    }
  }

  .external-link {
    i {
      color: #999;
      font-size: .75em;
      margin-left: .5em;
    }
  }

  .navbar-item {
    &:focus-within {
      background-color: transparent;
    }
  }
}
</style>

<style lang="scss">
.b-tooltip.analytics-tooltip.is-multiline {
  .close-button {
    cursor: pointer;
  }

  .tooltip-content {
    width: 370px;
    padding: 1.7em 1.9em;
    border-radius: 10px;

    p {
      color: white;
    }
  }
}
</style>
